import React from "react";
import styles from "./DashboardCard.module.css";

const DashboardCard = ({ title, value, change, prefix = "" }) => {
  return (
    <div className={styles["dashboard-card"]}>
      <div className={styles["card-title"]}>{title}</div>
      <div className={styles["card-value-container"]}>
        <div className={styles["card-value"]}>
          {prefix}
          {value}
        </div>
        {change !== undefined && (
          <div
            className={`${styles["card-change"]} ${
              change >= 0 ? styles.positive : styles.negative
            }`}
          >
            {change >= 0 ? "+" : ""}
            {change}%
          </div>
        )}
      </div>
    </div>
  );
};

export default DashboardCard;
